namespace $.$$ {
	$mol_style_define( $bog_calculator_app , {
		
	})
}
